<template>
  <v-row no-gutters>
    <v-navigation-drawer
      hide-overlay
      permanent
      color="transparent"
      :right="$vuetify.rtl"
      style="z-index: 0 !important"
      height="600"
    >
      <template v-slot:prepend>
        <v-text-field
          v-model="materialCategoriesSearch"
          class="me-2"
          :loading="materialCategoriesLoading"
        >
        </v-text-field>
      </template>
      <v-sheet>
        <v-treeview
          :items="materialCategoriesFiltered"
          :search="materialCategoriesSearch"
          :open.sync="materialCategoriesOpend"
          :active.sync="materialCategoriesActived"
          item-key="id"
          item-children="categories"
          open-all
          dense
          shaped
          hoverable
          activatable
          return-object
        >
          <template v-slot:label="{ item }">
            <v-badge
              :color="categoryDetailCount(item) > 0 ? 'accent' : 'transparent'"
              left
              dot
              offset-x="10"
              offset-y="4"
              class="my-2 ps-2"
            >
              {{ item.name }}
            </v-badge>
          </template>
        </v-treeview>
      </v-sheet>
    </v-navigation-drawer>

    <v-col>
      <ValidationObserver ref="observer">
        <v-data-iterator
          v-if="materials && materials.length > 0"
          :items="materials"
          disable-pagination
          hide-default-footer
          class="pt-1 pe-1 me-n1"
          style="height: 600px; overflow-y: scroll !important"
        >
          <template v-slot:no-data>
            <v-row class="pt-2">
              <v-spacer />
              <span class="subtitle-2 grey--text">
                {{ $t("$vuetify.noDataText") }}
              </span>
              <v-spacer />
            </v-row>
          </template>
          <template v-slot:no-result>
            <v-row class="pt-2">
              <v-spacer />
              <span class="subtitle-2 grey--text">
                {{ $t("$vuetify.noDataText") }}
              </span>
              <v-spacer />
            </v-row>
          </template>
          <template v-slot:header>
            <v-progress-linear
              v-if="materialsLoading"
              :indeterminate="materialsLoading"
              class="mt-n1"
            ></v-progress-linear>
          </template>
          <template v-slot:default="props">
            <v-row no-gutters class="mt-n1">
              <v-col v-for="item in props.items" :key="item.id" cols="12">
                <v-card tile elevation="0">
                  <v-row no-gutters>
                    <v-avatar
                      v-if="accountSettings && accountSettings.material_image"
                      tile
                      color="bgGrey"
                      style="vertical-align: top"
                      class="ma-1"
                    >
                      <v-menu open-on-hover>
                        <template v-slot:activator="{ on, attrs }">
                          <v-img
                            v-bind="attrs"
                            v-on="on"
                            v-if="item.thumbnail || item.material_img"
                            alt="Avatar"
                            :src="
                              item.thumbnail
                                ? item.thumbnail
                                : item.material_img +
                                  '?x-image-process=style/160x160'
                            "
                          />
                        </template>
                        <v-img :src="item.material_img" width="160" />
                      </v-menu>
                    </v-avatar>
                    <v-col
                      :class="
                        !(accountSettings && accountSettings.material_image)
                          ? 'ma-1'
                          : ''
                      "
                    >
                      <v-row no-gutters>
                        <v-col>
                          <v-row no-gutters>
                            <v-chip
                              class="pa-1 ml-1"
                              color="blue lighten-1"
                              label
                              x-small
                              text-color="white"
                              v-if="item.campaign"
                              style="
                                -webkit-transform: scale(0.7);
                                -webkit-transform-origin: 0 0;
                              "
                            >
                              {{ item.campaign ? item.campaign.name : "" }}
                            </v-chip>
                          </v-row>

                          <v-row no-gutters>
                            <span
                              class="d-block text-truncate"
                              v-if="
                                item.standard_name &&
                                item.standard_name.length > 12
                              "
                              :title="item.standard_name"
                              style="cursor: pointer"
                            >
                              {{
                                accountSettings
                                  ? $t(
                                      accountSettings
                                        ? accountSettings.material_name_display_type ==
                                          3
                                          ? "Material.materialNameWithCodeAndStandard"
                                          : accountSettings.material_name_display_type ==
                                            2
                                          ? "Material.materialNameWithCode"
                                          : "Material.materialName"
                                        : "Material.materialName",
                                      [
                                        item.material_code,
                                        item.material_name,
                                        item.standard_name.slice(0, 12) +
                                          "......",
                                      ]
                                    )
                                  : item.material_name
                              }}
                            </span>
                            <span v-else class="d-block text-truncate">
                              {{
                                accountSettings
                                  ? $t(
                                      accountSettings
                                        ? accountSettings.material_name_display_type ==
                                          3
                                          ? "Material.materialNameWithCodeAndStandard"
                                          : accountSettings.material_name_display_type ==
                                            2
                                          ? "Material.materialNameWithCode"
                                          : "Material.materialName"
                                        : "Material.materialName",
                                      [
                                        item.material_code,
                                        item.material_name,
                                        item.standard_name,
                                      ]
                                    )
                                  : item.material_name
                              }}
                            </span>
                            <v-spacer />
                            <v-icon
                              v-if="
                                accountSettings &&
                                accountSettings.order_detail_memo
                              "
                              small
                              class="pa-0 primary--text"
                              :disabled="
                                !orderDetailsMap[item.material_id_unit]
                              "
                              @click.stop="
                                $emit(
                                  'memo',
                                  orderDetailsMap[item.material_id_unit]
                                )
                              "
                            >
                              fa-edit
                            </v-icon>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row no-gutters class="mt-1">
                        <v-col
                          cols="12"
                          md="6"
                          class="subtitle-2 secondary--text pe-2"
                        >
                          <v-text-field
                            v-if="item.editPrice"
                            v-model="
                              orderDetailsMap[item.material_id_unit].price
                            "
                            :placeholder="
                              String(
                                $numberFormatter.formatTwoDot(
                                  orderDetailsMap[item.material_id_unit]
                                    ? orderDetailsMap[item.material_id_unit]
                                        .price
                                      ? orderDetailsMap[item.material_id_unit]
                                          .price
                                      : orderDetailsMap[item.material_id_unit]
                                          .org_price
                                    : item.supply_price,
                                  2
                                )
                              )
                            "
                            single-line
                            dense
                            hide-details
                            type="number"
                            min="0"
                            :prefix="$t('Global.money')"
                            :suffix="
                              '/ ' + orderDetailsMap[item.material_id_unit] &&
                              orderDetailsMap[item.material_id_unit].unit
                                ? orderDetailsMap[item.material_id_unit].unit
                                : item.unit
                            "
                            @blur="
                              orderDetailsMap[item.material_id_unit].price =
                                $numberFormatter.formatTwoDot(
                                  orderDetailsMap[item.material_id_unit]
                                    ? orderDetailsMap[item.material_id_unit]
                                        .price
                                      ? orderDetailsMap[item.material_id_unit]
                                          .price
                                      : orderDetailsMap[item.material_id_unit]
                                          .org_price
                                    : item.supply_price,
                                  2
                                )
                            "
                            class="mt-n1 d-inline-block"
                            style="max-width: 110px"
                            @input="
                              $emit('update', {
                                material:
                                  orderDetailsMap[item.material_id_unit],
                              })
                            "
                          />
                          <span v-else>
                            {{ $t("Global.money") }}
                            {{
                              orderDetailsMap[item.material_id_unit]
                                ? orderDetailsMap[item.material_id_unit].price
                                  ? orderDetailsMap[item.material_id_unit].price
                                  : orderDetailsMap[item.material_id_unit]
                                      .org_price
                                : item.supply_price | formatMoney
                            }}
                            / {{ item.unit }}
                          </span>
                          <span
                            v-if="item.barcode"
                            class="caption secondary--text"
                          >
                            [{{ item.barcode }}]
                          </span>
                          <span
                            v-if="item.rate > 1"
                            class="caption secondary--text"
                          >
                            (1{{ item.unit }}={{ item.rate
                            }}{{ item.default_unit }})
                          </span>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-row no-gutters dense>
                            <v-spacer />
                            <ValidationProvider
                              v-slot="{ errors }"
                              :rules="itemRules(item)"
                            >
                              <NumberInput
                                :value="
                                  orderDetailsMap[item.material_id_unit]
                                    ? orderDetailsMap[item.material_id_unit]
                                        .fix_num
                                    : ''
                                "
                                :error-messages="errors"
                                dense
                                class="mt-n1"
                                @input="itemNumChange(item, $event)"
                              />
                            </ValidationProvider>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row no-gutters class="mt-1">
                        <v-col
                          cols="12"
                          md="6"
                          class="subtitle-2 secondary--text pe-3"
                        >
                          <v-row no-gutters dense>
                            <v-col md="6">
                              {{ $t("MaterialTemplate.Fields.multiple") }}
                              {{ $t("Global.colon") }}
                              <span v-if="item.multiple">
                                {{ item.multiple | formatTwoDot }}
                              </span>
                              <span v-else>
                                {{ $t("Order.DetailFields.no_limit") }}
                              </span>
                            </v-col>
                            <v-col md="6">
                              {{ $t("MaterialTemplate.Fields.min_num") }}
                              {{ $t("Global.colon") }}
                              <span v-if="item.min_num">
                                {{ item.min_num | formatTwoDot }}
                                {{ item.unit }}
                              </span>
                              <span v-else>
                                {{ $t("Order.DetailFields.no_limit") }}
                              </span>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col
                          cols="12"
                          md="6"
                          class="subtitle-2 secondary--text pe-3"
                        >
                          <v-row no-gutters dense>
                            <v-col md="6">
                              <span
                                v-if="
                                  accountSettings &&
                                  accountSettings.oversell_setting == 1
                                "
                                class="subtitle-2 secondary--text"
                              >
                                {{
                                  $t(
                                    "MaterialTemplate.Fields.available_quantity"
                                  )
                                }}
                                {{ $t("Global.colon") }}
                                <span class="subtitle-2 secondary--text">
                                  <span
                                    v-if="
                                      'available_num' in item &&
                                      (item.available_num != null ||
                                        item.available_num != undefined ||
                                        item.available_num != 'undefined')
                                    "
                                  >
                                    <span v-if="item.rate > 1">
                                      {{
                                        item.supply_available_num | formatTwoDot
                                      }}
                                      {{ item.unit }}
                                    </span>
                                    <span v-else>
                                      {{ item.available_num | formatTwoDot }}
                                      {{ item.default_unit }}
                                    </span>
                                  </span>
                                  <span v-else>
                                    {{ $t("Order.DetailFields.no_limit") }}
                                  </span>
                                </span>
                              </span>
                              <span v-else class="subtitle-2 secondary--text">
                                {{
                                  $t("MaterialTemplate.Fields.stock_quantity")
                                }}
                                {{ $t("Global.colon") }}
                                <span v-if="item.rate > 1">
                                  {{ item.current_count_rate_with_unit }}
                                </span>
                                <span v-else>
                                  {{ item.current_count | formatTwoDot }}
                                  {{ item.default_unit }}
                                </span>
                              </span>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card>
                <v-divider />
              </v-col>
            </v-row>
          </template>
        </v-data-iterator>
        <v-data-iterator
          v-else
          :items="combineMaterials"
          disable-pagination
          hide-default-footer
          class="pt-1 pe-1 me-n1"
          style="height: 600px; overflow-y: scroll !important"
        >
          <template v-slot:no-data>
            <v-row class="pt-2">
              <v-spacer />
              <span class="subtitle-2 grey--text">
                {{ $t("$vuetify.noDataText") }}
              </span>
              <v-spacer />
            </v-row>
          </template>
          <template v-slot:no-result>
            <v-row class="pt-2">
              <v-spacer />
              <span class="subtitle-2 grey--text">
                {{ $t("$vuetify.noDataText") }}
              </span>
              <v-spacer />
            </v-row>
          </template>
          <template v-slot:header>
            <v-progress-linear
              v-if="materialsLoading"
              :indeterminate="materialsLoading"
              class="mt-n1"
            ></v-progress-linear>
          </template>
          <template v-slot:default="props">
            <v-row no-gutters class="mt-n1">
              <v-col v-for="item in props.items" :key="item.id" cols="12">
                <v-card tile elevation="0">
                  <v-row no-gutters>
                    <v-avatar
                      v-if="accountSettings && accountSettings.material_image"
                      tile
                      color="bgGrey"
                      style="vertical-align: top"
                      class="ma-1"
                    >
                      <v-menu open-on-hover>
                        <template v-slot:activator="{ on, attrs }">
                          <v-img
                            v-bind="attrs"
                            v-on="on"
                            v-if="item.thumbnail || item.img"
                            alt="Avatar"
                            :src="
                              item.thumbnail
                                ? item.thumbnail
                                : item.img + '?x-image-process=style/160x160'
                            "
                          />
                        </template>
                        <v-img :src="item.img" width="160" />
                      </v-menu>
                    </v-avatar>
                    <v-col
                      :class="
                        !(accountSettings && accountSettings.material_image)
                          ? 'ma-1'
                          : ''
                      "
                    >
                      <v-row no-gutters>
                        <span class="d-block text-truncate">
                          {{ item.material_name }}
                        </span>
                        <v-spacer />
                        <v-icon
                          v-if="
                            accountSettings && accountSettings.order_detail_memo
                          "
                          small
                          class="pa-0 primary--text"
                          :disabled="!orderDetailsMap[item.material_id]"
                          @click.stop="
                            $emit('memo', orderDetailsMap[item.material_id])
                          "
                        >
                          fa-edit
                        </v-icon>
                      </v-row>
                      <v-row no-gutters class="mt-1">
                        <v-col
                          cols="12"
                          md="6"
                          class="subtitle-2 secondary--text pe-2"
                        >
                          <span
                            v-for="(detail, index) in item.details"
                            :key="index"
                          >
                            {{ detail.material_name }}x{{ detail.combine_num
                            }}{{ detail.unit
                            }}{{ index != item.details.length - 1 ? "," : "" }}
                          </span>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-row no-gutters dense>
                            <v-spacer />
                            <ValidationProvider
                              v-slot="{ errors }"
                              :rules="combineItemRules(item)"
                            >
                              <NumberInput
                                :value="
                                  orderCombineDetailsMap[item.id]
                                    ? orderCombineDetailsMap[item.id].fix_num
                                    : ''
                                "
                                :error-messages="errors"
                                dense
                                class="mt-n1"
                                @input="combineItemNumChange(item, $event)"
                              />
                            </ValidationProvider>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row no-gutters class="mt-1">
                        <v-col
                          cols="12"
                          md="6"
                          class="subtitle-2 secondary--text pe-3"
                        >
                          <v-row no-gutters dense>
                            <v-col md="5">
                              {{ $t("Global.money") }}
                              {{ item.price | formatMoney }}
                            </v-col>
                            <v-col md="7">
                              {{
                                $t(
                                  "MaterialOrderRule.mixProductRule.single_max_num"
                                )
                              }}
                              {{ $t("Global.colon") }}
                              <span v-if="Number(item.max)">
                                {{ item.max }}
                              </span>
                              <span v-else>
                                {{ $t("Order.DetailFields.no_limit") }}
                              </span>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col
                          cols="12"
                          md="6"
                          class="subtitle-2 secondary--text pe-3"
                        >
                          <v-row no-gutters dense>
                            <v-col md="6">
                              <span class="subtitle-2 secondary--text">
                                {{
                                  $t(
                                    "MaterialTemplate.Fields.available_quantity"
                                  )
                                }}
                                {{ $t("Global.colon") }}
                              </span>
                              <span class="subtitle-2 secondary--text">
                                <span
                                  v-if="
                                    'available_num' in item &&
                                    (item.available_num != null ||
                                      item.available_num != undefined ||
                                      item.available_num != 'undefined')
                                  "
                                >
                                  {{ item.available_num | formatTwoDot }}
                                </span>
                                <span v-else>
                                  {{ $t("Order.DetailFields.no_limit") }}
                                </span>
                              </span>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card>
                <v-divider />
              </v-col>
            </v-row>
          </template>
        </v-data-iterator>
      </ValidationObserver>
    </v-col>

    <MaterialDialog v-model="dialogMaterialID" />
    <CombineMaterialDialog
      v-model="dialogCombineMaterial"
      @dialogMaterialID="dialogMaterialID = $event"
    />
  </v-row>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import NumberInput from "@/components/plugins/NumberInput";
import CombineMaterialDialog from "./CombineMaterialDialog";
import MaterialDialog from "@/components/materials/plugins/Dialog";
import MaterialCategories from "@/api/material_categories";
import MaterialTemplates from "@/api/material_templates";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  name: "CardTemplateMaterials",

  components: {
    NumberInput,
    CombineMaterialDialog,
    MaterialDialog,
    ValidationObserver,
    ValidationProvider,
  },

  props: {
    shopId: Number,
    mode: String,
    value: Array,
    combineValue: Array,
  },

  computed: {
    isNew() {
      return this.mode == "new";
    },
    materialCategoriesFiltered() {
      var materialCategories = JSON.parse(
        JSON.stringify(this.materialCategories)
      );
      var cats = this.getMaterialCategoriesFiltered(materialCategories);
      if (this.materialCombineCategory)
        cats.splice(0, 0, {
          id: 0,
          name: this.materialCombineCategory,
        });
      return cats;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["accountSettings"]),
  },

  data: () => ({
    mobileBreakpoint: 800,
    materialCombineCategory: "",
    materialCategories: [],
    materialCategoriesLoading: false,
    materialCategoriesSearch: "",
    materialCategoriesOpend: [],
    materialCategoriesActived: [],
    materialCategoriesCurrent: null,
    materialCategorySelected: null,
    materials: [],
    combineMaterials: [],
    materialsLoading: false,
    materialsSearch: "",
    dialogMaterialID: null,
    dialogCombineMaterial: null,
    orderDetailsMap: {},
    orderCombineDetailsMap: {},
    orderDetailsCategoriesMap: {},
    categoryIds: [],
  }),

  methods: {
    itemRules(item) {
      var rules = {};
      if (Number(item.multiple)) rules.multiple = { multiple: item.multiple };
      if (Number(item.min_num)) rules.min_value = { min: item.min_num };
      var max = Number(item.max_num ? item.max_num : 0);
      var available_num =
        "available_num" in item &&
        item.available_num != null &&
        item.available_num != undefined &&
        item.available_num != "undefined"
          ? Number(item.available_num)
          : null;
      if (item.rate > 1)
        available_num =
          "supply_available_num" in item &&
          item.supply_available_num != null &&
          item.supply_available_num != undefined &&
          item.supply_available_num != "undefined"
            ? Number(item.supply_available_num)
            : null;
      if (max && available_num != null)
        rules.max_value = { max: Math.min(max, available_num) };
      else if (max) rules.max_value = { max: max };
      else if (available_num != null) rules.max_value = { max: available_num };
      return rules;
    },
    itemNumChange(item, num) {
      var detail = this.orderDetailsMap[item.material_id_unit];
      if (detail) {
        switch (this.mode) {
          case "new": // 新建订单时
            detail.apply_num = num;
            break;
          case "confirm": // 确认订单时
            detail.confirm_num = num;
            break;
          case "edit": // 编辑（追加）订单时
            detail.fix_num = num;
            break;
        }
        if (num > 0) {
          this.materials = this.materials.map((material) => {
            return material;
          });
        }
        this.$emit("update", { material: detail });
      } else {
        this.$emit("add", { material: item, num: num });
      }
    },
    combineItemRules(item) {
      var rules = {};
      rules.multiple = { multiple: 1 }; // 组合商品默认整数倍
      var max = Number.parseInt(item.max ? item.max : 0);
      var available_num =
        item.available_num &&
        item.available_num != null &&
        item.available_num != undefined &&
        item.available_num != "undefined"
          ? Number.parseInt(item.available_num)
          : null;
      if (max && available_num != null)
        rules.max_value = { max: Math.min(max, available_num) };
      else if (max) rules.max_value = { max: max };
      else if (available_num != null) rules.max_value = { max: available_num };
      return rules;
    },
    combineItemNumChange(item, num) {
      var detail = this.orderCombineDetailsMap[item.id];
      if (detail) {
        switch (this.mode) {
          case "new": // 新建订单时
            detail.apply_num = num;
            break;
          case "confirm": // 确认订单时
            detail.confirm_num = num;
            break;
          case "edit": // 编辑（追加）订单时
            detail.fix_num = num;
            break;
        }
        this.$emit("update", { combineMaterial: detail });
      } else {
        this.$emit("add", { combineMaterial: item, num: num });
      }
    },
    getMaterialCategoriesFromAPI() {
      this.materialCategoriesLoading = true;
      MaterialTemplates.combineMaterialCategoryByShop(this.shopId)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.materialCombineCategory =
                response.data.combine_material_category;
              MaterialCategories.materialTree({
                shop_id: this.shopId,
              })
                .then(
                  function (response) {
                    if (response.data.status.isOK()) {
                      this.materialCategories = response.data.categories;
                    }
                    this.materialCategoriesLoading = false;
                  }.bind(this)
                )
                .catch(
                  function () {
                    this.materialCategoriesLoading = false;
                  }.bind(this)
                );
            }
            this.materialCategoriesLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.materialCategoriesLoading = false;
          }.bind(this)
        );
    },
    getMaterialCategoriesFiltered(categories) {
      return categories.filter((category) => {
        category.categories = this.getMaterialCategoriesFiltered(
          category.categories
        ); // 递归下级分类
        if (
          (category.categories && category.categories.length > 0) || // 下级分类中有挂商品的
          (category.material_count && Number(category.material_count) > 0) // 和自身有挂商品的
        )
          return true; // 符合筛选条件
      });
    },
    categoryDetailCount(item) {
      var detail_count = this.orderDetailsCategoriesMap[item.code]
        ? this.orderDetailsCategoriesMap[item.code].length
        : 0;
      if (item.categories)
        item.categories.forEach((category) => {
          detail_count += this.categoryDetailCount(category);
        });
      return detail_count ? detail_count : 0;
    },
    getCategoryParentCodeAndChildCode(categories) {
      categories.map((e) => {
        if (this.categoryIds.indexOf(e.id) == -1) {
          this.categoryIds.push(e.id);
        }
        if (e.categories.length) {
          this.getCategoryParentCodeAndChildCode(e.categories);
        }
      });
    },
    getCombineMaterialsFromAPI() {
      this.materialsLoading = true;
      MaterialTemplates.fetchCombineMaterialsByShop(this.shopId).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.materials = [];
            this.combineMaterials = response.data.combine_materials;
            this.categoryIds = [];
            this.attachOrderDetailToMaterial();
            this.materialsLoading = false;
          }
        }.bind(this)
      );
    },
    getMaterialsFromAPI() {
      if (this.materialCategoriesActived[0].rank == 1) {
        this.getCategoryParentCodeAndChildCode(this.materialCategoriesActived);
      } else {
        this.categoryIds = this.materialCategoriesActived.map(
          (element) => element.id
        );
      }

      this.materialsLoading = true;
      MaterialTemplates.fetchByShop(this.shopId, {
        category_ids: this.categoryIds,
        hide_flgs: [0],
      })
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.materials = response.data.template_details.map(
                (material) => {
                  this.makeStockCurrent(material);
                  var new_material = Object.assign({}, material, {
                    editPrice: false,
                    material_id_unit:
                      material.material_id + "-" + material.unit,
                  });
                  return new_material;
                }
              );
              this.combineMaterials = [];
              this.categoryIds = [];
              this.attachOrderDetailToMaterial();
            }
            this.materialsLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.materialsLoading = false;
          }.bind(this)
        );
    },
    attachOrderDetailToMaterial() {
      if (this.combineMaterials && this.value) {
        this.orderCombineDetailsMap = {};
        this.value.forEach((detail) => {
          var combineMaterial = this.combineMaterials.find(
            (combineMaterial) => combineMaterial.id == detail.ruler_id
          );
          if (combineMaterial) {
            this.orderCombineDetailsMap[detail.ruler_id] = detail;
          }
        });
      }
      if (this.materials && this.value) {
        this.orderDetailsMap = {};
        this.value.forEach((detail) => {
          var material = this.materials.find(
            (material) => material.material_id_unit == detail.material_id_unit
          );
          if (material) {
            this.orderDetailsMap[detail.material_id_unit] = detail;
          }
        });
      }
    },
    makeStockCurrent(detail) {
      //按要货单位换算当前库存量
      if (detail.rate > 1) {
        detail.current_count_rate = this.$numberFormatter.formatTwoDot(
          detail.current_count / detail.rate,
          true
        );
        var current_count_rate_int = parseInt(
          detail.current_count / detail.rate
        );
        if (detail.current_count % detail.rate) {
          var current_count_rate_float = detail.current_count % detail.rate;
          detail.current_count_rate_with_unit = i18n.t(
            "Order.DetailFields.quantityWithMultipleUnits",
            [
              current_count_rate_int,
              detail.unit,
              current_count_rate_float,
              detail.default_unit,
            ]
          );
        } else {
          detail.current_count_rate_with_unit = i18n.t(
            "Order.DetailFields.quantityWithUnit",
            [current_count_rate_int, detail.unit]
          );
        }
      }
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      deep: true,
      handler() {
        this.orderDetailsCategoriesMap = {};
        this.value.forEach((detail) => {
          if (!this.orderDetailsCategoriesMap[detail.category_code])
            this.orderDetailsCategoriesMap[detail.category_code] = [];
          this.orderDetailsCategoriesMap[detail.category_code].push(detail);
        });
        this.attachOrderDetailToMaterial();
      },
    },
    shopId: {
      immediate: true, //初始赋值也调用
      handler() {
        if (typeof this.shopId != "undefined" && this.shopId != null)
          this.getMaterialCategoriesFromAPI();
      },
    },
    materialCategoriesFiltered: {
      handler() {
        if (this.materialCategoriesFiltered.length > 0)
          this.materialCategoriesActived = [this.materialCategoriesFiltered[0]];
        // this.materialCategoriesActived = [{ id: 12 }]; // for test},
        else this.materialCategoriesActived = [];
      },
    },
    materialCategoriesActived: {
      handler() {
        if (
          this.materialCategoriesActived.length == 0 &&
          this.materialCategoriesCurrent
        )
          this.materialCategoriesActived = [this.materialCategoriesCurrent];

        this.materialCategoriesActived.forEach((element) => {
          if (!this.materialCategoriesOpend.find((e) => e == element))
            this.materialCategoriesOpend.push(element);
        });
        this.materialCategoriesCurrent = this.materialCategoriesActived[0];
      },
    },
    materialCategoriesCurrent: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.shopId && this.materialCategoriesCurrent) {
          if (!this.materialCategoriesCurrent.id)
            this.getCombineMaterialsFromAPI();
          else this.getMaterialsFromAPI();
        }
      },
    },
    orderDetailsMap: {
      deep: true,
      handler() {
        let orderDetails = Object.values(this.orderDetailsMap);
        orderDetails.forEach((order_detail) => {
          if (order_detail.fix_num > 0) {
            this.materials = this.materials.map((material) => {
              return material;
            });
          }
        });
      },
    },
  },
};
</script>
